"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import i18n from "@/lang";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { Debounce } from "vue-debounce-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import { UploadFeedbackManagerWrap } from "@/utils/UploadFeedbackManager";
class FeedBackFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.feedback_type = "product.opinion";
    this.feedback_description = "";
    this.feedback_connection = "";
    // @UiFormAnnotations.Rule([
    //   {
    //     required: true,
    //     message: i18n.t("feedbackform.feedback_upload_not_null") as string,
    //     trigger: "blur",
    //   },
    // ])
    this.feedback_upload = [];
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("feedbackform.please_choose_feedback_type"),
      trigger: "blur"
    }
  ])
], FeedBackFormController.prototype, "feedback_type", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("feedbackform.please_choose_feedback_description"),
      trigger: "blur"
    }
  ])
], FeedBackFormController.prototype, "feedback_description", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("feedbackform.feedback_connection_not_null"),
      trigger: "blur"
    }
  ])
], FeedBackFormController.prototype, "feedback_connection", 2);
let FeedBackForm = class extends Vue {
  constructor() {
    super(...arguments);
    this.formController = new FeedBackFormController();
    this.uploadDialogVisible = false;
    this.dialogImageUrl = "";
    this.uploadManager = new UploadFeedbackManagerWrap();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  typeChange() {
  }
  handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.uploadDialogVisible = true;
  }
  beforeAvatarUpload(file, fileList) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG && !isPNG) {
      this.$message.error(this.$t("feedbackform.feedback_upload_file_type_warning"));
      this.feedback_upload.abort(file);
      fileList.splice(fileList.indexOf(file), 1);
      return;
    }
    if (!isLt2M) {
      this.$message.error(this.$t("feedbackform.feedback_upload_file_size_warning"));
      this.feedback_upload.abort(file);
      fileList.splice(fileList.indexOf(file), 1);
      return;
    }
  }
  handleChange(file, fileList) {
    this.beforeAvatarUpload(file.raw, fileList);
    this.formController.feedback_upload = [];
    for (const fileItem of fileList) {
      this.formController.feedback_upload.push(fileItem.raw);
    }
  }
  handleRemove(file, fileList) {
    this.formController.feedback_upload = [];
    for (const fileItem of fileList) {
      this.formController.feedback_upload.push(fileItem.raw);
    }
  }
  handleExceed(file, fileList) {
    this.$message.error(this.$t("feedbackform.feedback_upload_file_num_warning"));
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let file_uid = null;
        let files = [];
        if (this.formController.feedback_upload.length > 0) {
          const upload_result = yield this.uploadManager.start(this.formController.feedback_upload);
          file_uid = upload_result[0].ossId;
          for (const uploadResult of upload_result) {
            let Item = {
              "file_path": uploadResult.name,
              "file_real_name": uploadResult.real_name
            };
            files.push(Item);
          }
        }
        let upLoadData = {
          "type": this.formController.feedback_type,
          "comment": this.formController.feedback_description,
          "contact": this.formController.feedback_connection,
          "files": files
        };
        if (file_uid !== null) {
          upLoadData = {
            "type": this.formController.feedback_type,
            "comment": this.formController.feedback_description,
            "contact": this.formController.feedback_connection,
            "file_uid": file_uid,
            "files": files
          };
        }
        yield API.post(`api://base.auth/api/v1/comment`, upLoadData);
        this.clearForm();
        this.feedback_success_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeDialog() {
    this.feedback_success_dialog.hide();
  }
  clearForm() {
    this.feedback_upload.clearFiles();
    this.formController.clear();
    this.formController.feedback_type = "product.opinion";
  }
};
__decorateClass([
  Ref("feedbackUpload")
], FeedBackForm.prototype, "feedback_upload", 2);
__decorateClass([
  Ref("feedback-success-dialog")
], FeedBackForm.prototype, "feedback_success_dialog", 2);
__decorateClass([
  Debounce(400)
], FeedBackForm.prototype, "submit", 1);
FeedBackForm = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], FeedBackForm);
export {
  FeedBackForm as default
};
